<template>
	<div
		class="container-wrap"
		:class="{ 'rtr_wallet_account-assets': true, 'mobile-layout': isMobile }"
	>
		<div class="container-box">
			<div :class="isMobile ? 'd_block' : 'd_flex'">
				<div
					:class="
						isMobile
							? 'assets_list_area mobile-full mb_20'
							: 'assets_list_area mr_20'
					"
				>
					<div class="card mb_10">
						<h3 class="title">
							<img
								:src="iconAssetList"
								alt=""
								:style="
									isMobile
										? { width: '20px', height: '20px' }
										: { width: '24px', height: '24px' }
								"
							/>{{ $t('rtr_wallet_account-assets.title1') }}
						</h3>
					</div>
					<div class="card type1 mb_0">
						<div v-if="0" class="search_area">
							<input type="text" v-model="searchKeyword" />
							<a class="search_icon SEARCH"></a>
						</div>

						<div class="">
							<ul v-if="0" class="tab_area">
								<li :class="{ selected: selectedTab === 1 }">
									<a class="tab_item" @click="tabSelect(1)"
										><span>{{ $t('rtr_wallet_account-assets.tab1') }}</span></a
									>
								</li>
								<li :class="{ selected: selectedTab === 2 }">
									<a class="tab_item" @click="tabSelect(2)"
										><span>{{ $t('rtr_wallet_account-assets.tab2') }}</span></a
									>
								</li>
							</ul>

							<div class="asset_list_wrap">
								<!--                자산 탭 표시-->
								<div v-if="selectedTab === 1">
									<ul class="asset_area">
										<li v-for="item in allAssets" :key="item.seq">
											<input
												:id="item.code"
												type="radio"
												class="assets_list_item"
												name="assets"
												:value="item.seq"
												v-model="selectedAssetSeq"
											/>
											<label class="asset_box asset_list_box" :for="item.code">
												<span
													:class="[
														'icon ' + item.code,
														isMobile ? 'small' : 'medium',
													]"
												></span>
												<p class="code mb_0">{{ item.code }}</p>
												<p class="name mb_0">{{ item.title }}</p>
											</label>
											<span
												v-if="0"
												:class="[{ bookmarked: item.bookmark === 'Y' }, 'STAR']"
												@click="favoriteAssetHandler(item.seq)"
											></span>
										</li>
									</ul>
								</div>
								<!--                즐겨찾기 탭-->
								<div v-if="selectedTab === 2">
									<ul class="asset_area">
										<template v-for="item in allAssets" :key="item.seq">
											<li v-if="item.bookmark === 'Y'">
												<input
													:id="item.code"
													type="radio"
													class="assets_list_item"
													name="assets"
													:value="item.seq"
													v-model="selectedAssetSeq"
												/>
												<label
													class="asset_box asset_list_box"
													:for="item.code"
												>
													<span
														:class="[
															'icon ' + item.code,
															isMobile ? 'small' : 'medium',
														]"
													></span>
													<div>
														<p class="code mb_4">{{ item.code }}</p>
														<p class="name">{{ item.title }}</p>
													</div>
												</label>
												<span
													:class="[
														{ bookmarked: item.bookmark === 'Y' },
														'STAR',
													]"
													@click="favoriteAssetHandler(item.seq)"
												></span>
											</li>
										</template>
									</ul>
								</div>
							</div>
						</div>
						<div
							:class="
								isMobile
									? 'mb_10 d_flex link_area mt_20'
									: 'd_flex link_area mb_10'
							"
						>
							<div class="flex_grow">
								<router-link :to="{ name: 'pay-exchange' }">
									<div id="send" class="btn btn-exchange">
										<img
											:src="iconExchange"
											alt=""
											:style="
												isMobile
													? { width: '14px', height: '14px' }
													: { width: '18px', height: '18px' }
											"
										/>
										<p class="fc_white">{{ $t('menu.pay-exchange') }}</p>
									</div>
								</router-link>
							</div>
							<div class="flex_grow">
								<router-link :to="{ name: 'pay-c2c' }">
									<div id="request" class="btn btn-p2p">
										<img
											:src="iconP2P"
											alt=""
											:style="
												isMobile
													? { width: '14px', height: '14px' }
													: { width: '18px', height: '18px' }
											"
										/>
										<p>{{ $t('menu.pay-c2c') }}</p>
									</div>
								</router-link>
							</div>
						</div>
						<div class="d_flex justify_between link_area">
							<div class="flex_grow">
								<router-link :to="{ name: 'activity-exchange' }">
									<div id="history" class="btn btn-exchange-detail">
										<img
											:src="iconExchangeDetail"
											alt=""
											:style="
												isMobile
													? { width: '14px', height: '14px' }
													: { width: '18px', height: '18px' }
											"
										/>
										<p>{{ $t('menu.activity-exchange') }}</p>
									</div>
								</router-link>
							</div>
						</div>
					</div>
				</div>
				<div
					:class="
						isMobile ? 'assets_detail_area mobile-full' : 'assets_detail_area'
					"
				>
					<div class="card mb_10">
						<h3 class="title">
							<img
								:src="iconWalletAccount"
								alt=""
								:style="
									isMobile
										? { width: '20px', height: '20px' }
										: { width: '24px', height: '24px' }
								"
							/>
							{{ $t('rtr_wallet_account-assets.title2') }}
						</h3>
					</div>
					<div v-if="!isRegistMode" class="card type1 mb_0">
						<div class="asset_detail_wrap">
							<div v-if="selectedAsset">
								<div v-if="selectedAccount">
									<div class="bg_blue_box">
										<div>
											<div :class="['asset_box', isMobile ? '' : 'mb_60']">
												<span
													:class="[
														selectedAccount.asset_code,
														isMobile ? 'small' : 'medium',
													]"
												></span>
												<div>
													<p :class="['code', isMobile ? 'mb_0' : 'mb_4']">
														{{ selectedAccount.asset_code }}
													</p>
													<p class="name">
														{{ selectedAccount.asset_title }}
													</p>
												</div>
											</div>
											<div class="balance_area">
												<div class="quantity">
													{{ selectedAccount.balance }}
												</div>
												<span class="currency">
													{{ selectedAccount.asset_code }}
												</span>
											</div>
										</div>
										<template v-if="0 && selectedAccount.asset_code === 'USDT'">
											<div class="button_area justify_between">
												<button class="button_blue" @click="notYet">
													{{ $t('account-wallet.btn_charge') }}
												</button>
												<div>
													<button
														class="mr_5"
														@click="toSend(selectedAccount.seq)"
													>
														<img
															:src="iconExchange"
															alt=""
															:style="
																isMobile
																	? { width: '12px', height: '12px' }
																	: { width: '18px', height: '18px' }
															"
														/>
														{{ $t('button.send') }}
													</button>
													<button
														class=""
														@click="toDeposit(selectedAccount.seq)"
													>
														<img
															:src="iconMsgWhite"
															alt=""
															:style="
																isMobile
																	? { width: '12px', height: '12px' }
																	: { width: '18px', height: '18px' }
															"
														/>
														{{ $t('button.request') }}
													</button>
												</div>
											</div>
										</template>

										<template v-else>
											<div class="button_area">
												<button
													class="mr_5"
													@click="toSend(selectedAccount.seq)"
												>
													<img
														:src="iconExchange"
														alt=""
														:style="
															isMobile
																? { width: '12px', height: '12px' }
																: { width: '18px', height: '18px' }
														"
													/>
													{{ $t('button.send') }}
												</button>
												<button
													class=""
													@click="toDeposit(selectedAccount.seq)"
												>
													<img
														:src="iconMsgWhite"
														alt=""
														:style="
															isMobile
																? { width: '12px', height: '12px' }
																: { width: '18px', height: '18px' }
														"
													/>
													{{ $t('button.request') }}
												</button>
											</div>
										</template>
									</div>

									<!--									<template v-if="selectedAccount.asset_code === 'USDT'">-->
									<!--										<span class="divide_line"></span>-->
									<!--										<p style="text-align: center; margin-top: 126px">-->
									<!--											{{ $t('account-wallet.text1') }}-->
									<!--										</p>-->
									<!--									</template>-->

									<!--									<template v-else>-->
									<!-- <template
										v-if="
											selectedAccount.asset_code !== 'USDT' &&
											selectedAccount.address
										"
									> -->
									<div class="qr_area">
										<p
											v-if="0 && selectedAccount.asset_code === 'USDT'"
											class="if_USDT mb_10"
										>
											{{ $t('rtr_wallet_account-assets.account') }}
										</p>
										<ul v-else class="tab_area">
											<li
												:class="[{ selected: qrTab === 'account' }, 'tab_item']"
												@click="qrTab = 'account'"
											>
												<a>{{ $t('rtr_wallet_account-assets.account') }}</a>
											</li>
											<li
												v-if="selectedAccount.address"
												:class="[{ selected: qrTab === 'address' }, 'tab_item']"
												@click="qrTab = 'address'"
											>
												<a>{{ $t('rtr_wallet_account-assets.address') }}</a>
											</li>
										</ul>
										<swiper
											:slidesPerView="1"
											:navigation="true"
											:modules="modules"
											@swiper="onSwiper"
											@slideChange="onSwiperChange"
										>
											<swiper-slide>
												<div class="qr_box">
													<div class="qr_image_wrap">
														<Qrcode
															id="accountQr"
															:color="{
																dark: '#000000ff',
																light: '#ffffffff',
															}"
															type="image/png"
															:quality="1"
															:margin="1"
															:value="selectedAccount.account_number"
														/>
													</div>
													<div class="copy_box">
														<div class="copy_title">
															{{ $t('rtr_wallet_account-assets.account') }}
															number
														</div>
														<div class="copy_cont">
															<p class="address mb_15" @click="copyAccount">
																{{ selectedAccount.account_number }}
															</p>
															<a
																class=""
																@click="copyClipboard('account_number')"
															>
																<img
																	:src="iconCopyWhite"
																	alt=""
																	style="width: 18px; height: 18px"
																/>
															</a>
														</div>
													</div>
													<a
														class="qr_download"
														@click="qrDownload('accountQr')"
														><img
															src="@/assets/images/v2/icon/icon-down-white.svg"
															alt="qr download icon"
															style="width: 18px; height: 18px"
														/>
														Download</a
													>
												</div>
											</swiper-slide>
											<swiper-slide v-if="selectedAccount.address">
												<div class="qr_box">
													<div class="qr_image_wrap">
														<Qrcode
															id="addressQr"
															:color="{
																dark: '#000000ff',
																light: '#ffffffff',
															}"
															type="image/png"
															:quality="1"
															:margin="1"
															:value="selectedAccount.address"
														/>
													</div>
													<div class="copy_box">
														<div class="copy_title">
															{{ $t('rtr_wallet_account-assets.address') }}
															code
														</div>
														<div class="copy_cont">
															<p class="address">
																{{ selectedAccount.address }}
															</p>
															<a class="" @click="copyClipboard('address')">
																<img
																	:src="iconCopyWhite"
																	alt=""
																	style="width: 18px; height: 18px"
																/>
															</a>
														</div>
													</div>

													<a
														class="qr_download"
														@click="qrDownload('addressQr')"
														><img
															src="@/assets/images/v2/icon/icon-down-white.svg"
															alt=""
															style="width: 18px; height: 18px"
														/>
														Download</a
													>
												</div>
											</swiper-slide>
										</swiper>
									</div>
									<!--									</template>-->
								</div>
								<!--                자산 없을때-->
								<div v-else>
									<div class="empty_set empty_wallet">
										<span class="add_wallet"></span>
										<a @click="toAccountRegist">
											<p>
												{{ $t('rtr_wallet_account-assets.text2') }}
											</p>
										</a>
									</div>
								</div>
							</div>
							<div v-else>
								<div class="empty_set">
									<span class="select_account"></span>
									<p>
										<img
											:src="iconSearch"
											alt=""
											style="width: 14px; height: 14px"
										/>{{ $t('rtr_wallet_account-assets.empty') }}
									</p>
								</div>
							</div>
						</div>
					</div>
					<div v-else class="card type1 mb_0">
						<div class="asset_detail_wrap">
							<h3 class="title mb_20">
								{{ $t('rtr_wallet_account-assets.title3') }}
							</h3>
							<account-register
								:asset-info="selectedAsset"
								@closeRegist="this.isRegistMode = false"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<ModalMessage v-if="messageModal" @closeModal="messageModal = false">
		<div class="status_icon error"></div>
		<p class="status_text">{{ $t('rtr_wallet_account-assets.text1') }}</p>
		<div class="button_area">
			<button class="fc_red oneBtn" @click="messageModal = false">
				{{ $t('rtr_auth-register.confirm') }}
			</button>
		</div>
	</ModalMessage>
</template>

<script>
import AccountRegister from '@/components/AccountRegister';
import { Navigation } from 'swiper';
import { mapGetters } from 'vuex';
import ModalMessage from '@/components/Layout/ModalMessage';
import iconAssetList from '@/assets/images/v2/icon/icon-asset-list.svg';
import iconWalletAccount from '@/assets/images/v2/icon/icon-wallet-account.svg';
import iconExchange from '@/assets/images/v2/icon/icon-exchange.svg';
import iconP2P from '@/assets/images/v2/icon/icon-p2p.svg';
import iconExchangeDetail from '@/assets/images/v2/icon/icon-exchange-detail.svg';
import iconPlusBlue from '@/assets/images/v2/icon/icon-plus-blue.svg';
import iconSearch from '@/assets/images/v2/icon/icon-search.svg';
import useClipboard from 'vue-clipboard3';
import iconMsgWhite from '@/assets/images/v2/icon/icon-msg-white.svg';
import iconCopyWhite from '@/assets/images/v2/icon/icon-copy-white.svg';
export default {
	name: 'AssetsList',
	components: { AccountRegister, ModalMessage },
	data() {
		return {
			selectedTab: 1,
			qrTab: 'account',
			favoriteAssetKey:
				'favoriteAsset_' + this.$store.state.auth.member_info.seq,
			favoriteAssetsSeq: [],
			selectedAssetSeq: null,
			isRegistMode: false,
			messageModal: false,
			searchKeyword: '',
			modules: [Navigation],
			swiper: null,
			isMobile: false,
			iconAssetList,
			iconWalletAccount,
			iconExchange,
			iconP2P,
			iconExchangeDetail,
			iconPlusBlue,
			iconSearch,
			iconMsgWhite,
			iconCopyWhite,
			// qrData: [
			// 	{ account_number: this.selectedAccount.account_number },
			// 	{ asset_code: this.selectedAccount.asset_code },
			// 	{ address: this.selectedAccount.address },
			// ],
		};
	},
	watch: {
		selectedAssetSeq() {
			this.isRegistMode = false;
			this.qrTab = 'account';
		},
		qrTab(value) {
			const index = value === 'account' ? 0 : 1;
			if (value) this.swiper.slideTo(index);
		},
	},
	computed: {
		...mapGetters('assets', ['assets']),
		...mapGetters('account', ['accounts']),
		allAssets() {
			const list = [];
			const result = [];
			this.assets.forEach(item => {
				if (item.code === 'USDT') {
					list.unshift(item);
				} else {
					list.push(item);
				}
			});
			list.forEach((item, idx) => {
				const index = this.favoriteAssetsSeq.indexOf(item.seq);
				if (index !== -1) list[idx] = { bookmark: 'Y', ...item };
				else list[idx] = { bookmark: 'N', ...item };
			});

			result.push(list[0]);

			list.forEach(item => {
				if (item.code === 'USDT') return;
				if (item.bookmark === 'Y') result.push(item);
			});
			list.forEach(item => {
				if (item.code === 'USDT') return;
				if (item.bookmark === 'N') result.push(item);
			});

			if (this.searchKeyword) {
				return list.filter(item => {
					return (
						item.code
							.toLowerCase()
							.includes(this.searchKeyword.toLowerCase()) ||
						item.title.toLowerCase().includes(this.searchKeyword.toLowerCase())
					);
				});
			} else {
				return result;
			}
		},
		selectedAsset() {
			return this.assets.find(item => {
				return item.seq === parseInt(this.selectedAssetSeq);
			});
		},
		selectedAccount() {
			return this.accounts.find(item => {
				return item.asset_seq === parseInt(this.selectedAssetSeq);
			});
		},
	},
	mounted() {
		if (localStorage.getItem(this.favoriteAssetKey)) {
			this.favoriteAssetsSeq = JSON.parse(
				localStorage.getItem(this.favoriteAssetKey),
			);
		}
		this.checkMobile();
		window.addEventListener('resize', this.checkMobile);
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.checkMobile);
	},
	methods: {
		checkMobile() {
			this.isMobile = window.innerWidth <= 768;
		},
		onSwiper(swiper) {
			this.swiper = swiper;
		},
		onSwiperChange(e) {
			this.qrTab = e.activeIndex === 0 ? 'account' : 'address';
		},
		tabSelect(e) {
			this.selectedTab = e;
		},
		favoriteAssetHandler(assetSeq) {
			const index = this.favoriteAssetsSeq.indexOf(assetSeq);
			if (index === -1) {
				// if (this.favoriteAssetsSeq.length === 5) {
				// 	this.messageModal = true;
				// 	return false;
				// }
				this.favoriteAssetsSeq.push(assetSeq);
			} else {
				this.favoriteAssetsSeq.splice(index, 1);
			}
			localStorage.setItem(
				this.favoriteAssetKey,
				JSON.stringify(this.favoriteAssetsSeq),
			);
		},
		toAccountRegist() {
			this.isRegistMode = true;
		},
		toSend(seq) {
			this.$router.push({
				name: 'pay-payment',
				query: { accountSeq: seq },
			});
		},
		toDeposit(seq) {
			this.$router.push({
				name: 'pay-deposit',
				query: { accountSeq: seq },
			});
		},
		qrDownload(id) {
			const dataUrl = document.getElementById(id).src;
			const link = document.createElement('a');
			link.href = dataUrl;
			link.download = 'qrcode';
			link.click();
		},
		copyClipboard(key) {
			try {
				useClipboard().toClipboard(this.selectedAccount[key]);
				alert(this.$t('alert.copy_s'));
			} catch (e) {
				alert(this.$t('alert.copy_f'));
			}
		},
		copyAddress() {
			try {
				useClipboard().toClipboard(this.selectedAccount.address);
				alert(this.$t('alert.copy_s'));
			} catch (e) {
				alert(this.$t('alert.copy_f'));
			}
		},
		copyAccount() {
			try {
				useClipboard().toClipboard(this.selectedAccount.account_number);
				alert(this.$t('alert.copy_s'));
			} catch (e) {
				alert(this.$t('alert.copy_f'));
			}
		},
		notYet() {
			alert(this.$t('alert.not_yet'));
		},
	},
	created() {
		if (this.$route.query.assetSeq) {
			this.selectedAssetSeq = this.$route.query.assetSeq;
		}
	},
};
</script>
